module.exports = __webpack_public_path__ + "img/facility.3c7414f3.jpg";